// 1..9 = £200 Amazon, 10 = Turkey Escape
export const REWARD_TIERS = [
  { n: 1, level: "Starter", type: "amazon", amount: 200, label_en: "£200 Amazon Gift Card", label_tr: "£200 Amazon Hediye Kartı" },
  { n: 2, level: "Starter", type: "amazon", amount: 200, label_en: "£200 Amazon Gift Card", label_tr: "£200 Amazon Hediye Kartı" },
  { n: 3, level: "Bronze", type: "amazon", amount: 200, label_en: "£200 Amazon Gift Card", label_tr: "£200 Amazon Hediye Kartı" },
  { n: 4, level: "Bronze", type: "amazon", amount: 200, label_en: "£200 Amazon Gift Card", label_tr: "£200 Amazon Hediye Kartı" },
  { n: 5, level: "Silver", type: "amazon", amount: 200, label_en: "£200 Amazon Gift Card", label_tr: "£200 Amazon Hediye Kartı" },
  { n: 6, level: "Silver", type: "amazon", amount: 200, label_en: "£200 Amazon Gift Card", label_tr: "£200 Amazon Hediye Kartı" },
  { n: 7, level: "Gold", type: "amazon", amount: 200, label_en: "£200 Amazon Gift Card", label_tr: "£200 Amazon Hediye Kartı" },
  { n: 8, level: "Gold", type: "amazon", amount: 200, label_en: "£200 Amazon Gift Card", label_tr: "£200 Amazon Hediye Kartı" },
  { n: 9, level: "Platinum", type: "amazon", amount: 200, label_en: "£200 Amazon Gift Card", label_tr: "£200 Amazon Hediye Kartı" },
  { n: 10, level: "Elite", type: "hotel", amount: 900, label_en: "Turkey Escape — 5-night all-inclusive for two", label_tr: "Türkiye Kaçamağı — İki kişi 5 gece her şey dâhil" },
];

export const TIER_COLORS = {
  Starter:  { bg: "#e5e7eb", ink: "#374151" },
  Bronze:   { bg: "#f2d3b3", ink: "#8a4a1e" },
  Silver:   { bg: "#e1e6ed", ink: "#4a5568" },
  Gold:     { bg: "#fbe4a4", ink: "#7a5a12" },
  Platinum: { bg: "#dfe7f0", ink: "#1f3a56" },
  Elite:    { bg: "#0b1521", ink: "#f4a261" },
  Bonus:    { bg: "#fcd7c6", ink: "#8a3d20" },
};

export const STATUS_KEYS = [
  "invitation_sent","details_submitted","contact_confirmed","consultation_booked",
  "treatment_plan_prepared","decision_pending","treatment_confirmed",
  "qualified_referral","reward_approved","reward_sent","not_eligible",
];
